import VueRouter from 'vue-router';

/**
 * Push user to signup/login route while remembering the intended destination
 * via the `redirect` query parameter.
 */
export function pushToAuth(router: VueRouter, targetPath: string) {
  router.push({
    name: 'landing',
    params: { openLoginPopup: 'true' },
    query: { redirect: encodeURIComponent(targetPath) }
  });
}

// Note: The old `consumeRedirect` helper became obsolete once the login dialog
// took over the redirect handling internally.  It has been removed.
